"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBody = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_2 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var uuid_1 = require("uuid");
var Cell_1 = require("../../atoms/Cell");
var Text_1 = require("../../atoms/Text");
var Checkbox_1 = require("../../atoms/Checkbox");
var styles_1 = __importDefault(require("./styles"));
/**
 * @deprecated
 */
exports.TableBody = react_2.default.memo(function (_a) {
    var data = _a.data, columnCount = _a.columnCount, checkboxes = _a.checkboxes, prepareRow = _a.prepareRow, _b = _a.emptyDataText, emptyDataText = _b === void 0 ? 'No data to show' : _b, _c = _a.onRowClick, onRowClick = _c === void 0 ? function () { } : _c, _d = _a.edit, edit = _d === void 0 ? false : _d, rest = __rest(_a, ["data", "columnCount", "checkboxes", "prepareRow", "emptyDataText", "onRowClick", "edit"]);
    var classes = (0, styles_1.default)({ edit: edit });
    var hasData = data && data.length > 0;
    var rowClickHandler = function (record) {
        // edit should prevent row clicking
        if (!edit) {
            onRowClick(record);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(core_1.TableBody, __assign({ className: classes.root }, { children: [!hasData && ((0, jsx_runtime_1.jsx)(core_1.TableRow, { children: (0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ colSpan: columnCount !== null && columnCount !== void 0 ? columnCount : columnCount }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ size: "medium" }, { children: emptyDataText })) })) })), hasData &&
                data.map(function (row) {
                    prepareRow(row);
                    return ((0, jsx_runtime_1.jsxs)(core_1.TableRow, __assign({ className: classes.row }, row.getRowProps(), { role: "row", onClick: function () { return rowClickHandler(row); } }, { children: [checkboxes && ((0, jsx_runtime_1.jsx)(Cell_1.Cell, __assign({ padding: "checkbox", className: classes.cell }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, __assign({ id: "id", label: "" }, rest)) }))), row.cells.map(function (cell, index) { return (
                            // NOTE: without proper types on cell the only way to guarantee uniqueness is to use index
                            (0, react_1.createElement)(Cell_1.Cell, __assign({}, cell.getCellProps(), { 
                                // eslint-disable-next-line react/no-array-index-key
                                key: "".concat(row.id, "-").concat(index), className: classes.cell, component: "td" }), cell.render('Cell'))); })] }), (0, uuid_1.v4)()));
                })] })));
});
